import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoQRCodeMixin from './KendoQRCodeMixin'

export default {
    name: 'kendo-qrcode',
    mixins: [ KendoQRCodeMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render (createElement) {
        const h = gh || createElement
        return h('span')
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-barcodes-vue-wrapper/src/KendoQRCode/index.js